// extracted by mini-css-extract-plugin
export default {"mn-choose-drawer-task":"index_mn-choose-drawer-task__LO3lZ"};